import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'newline'
})

export class NewLinePipe implements PipeTransform {
    transform(value: any): any {
        if (value) {
            return value.replace(/\n/g, '<br>');
        } else {
            return value;
        }
    }
}
